
import {
  RepoLocksRepositoryInterface,
  RepoLocksDto,
} from '@/services/Backup/interfaces';
import { AxiosError } from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import Themeable from 'vuetify/lib/mixins/themeable';
import BackupRepoDetailsDialog from '@/components/dialogs/backups/BackupRepoDetailsDialog.vue';
import DeleteBackupRepoDialog from '@/components/dialogs/backups/DeleteBackupRepoDialog.vue';
import PruneBackupRepoDialog from '@/components/dialogs/backups/PruneBackupRepoDialog.vue';

@Component({
  mixins: [Themeable],
  components: {
    DeleteBackupRepoDialog,
    PruneBackupRepoDialog,
    BackupRepoDetailsDialog,
  },
  inject: ['repoLocksRepository'],
})
export default class ActiveBackupRepos extends Vue {
  public loading: boolean = false;
  public currentPage: number = 1;
  public itemsPerPage: number = 10;
  public totalItems: number = 0;

  public repoLocksRepository!: RepoLocksRepositoryInterface;
  public backupRepoLocks: RepoLocksDto[] = [];

  public headers: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Repository Id', value: 'backupRepositoryId' },
    { text: 'Backup Server Id', value: 'backupServerId' },
    { text: 'Lock Type', value: 'type' },
    { text: 'Created At', value: 'createdAt' },
    { text: 'Expires At', value: 'ttl' },
    { text: 'Website IDs', value: 'websiteRestoreLocks' },
    { text: 'Actions', value: 'actions' },
  ];

  public typeLabels = {
    1: 'Forget Task Lock',
    2: 'Prune Task Lock',
    3: 'Backup Task Lock',
    4: 'Restore Task Lock',
    5: 'Terminated Backup Task Lock',
  }

  public async created(): Promise<void> {
    await this.initialize();
  }

  public async initialize(): Promise<void> {
    await this.search();
  }

  public async search(): Promise<void> {
    this.loading = true;
    try {
      await this.getBackupRepoLocks();
    } catch (err) {
      await this.onError(err);
    } finally {
      this.loading = false;
    }
  }

  public async getBackupRepoLocks(): Promise<void> {
    const result = await this.repoLocksRepository.searchReposLocks({
      page: this.currentPage,
      pageSize: this.itemsPerPage,
    });
    this.totalItems = result?.total ?? 0;
    this.backupRepoLocks = result?.data ?? [];
  }

  public async changePage(): Promise<void> {
    await this.search();
  }

  public async dropLock(id: number): Promise<void> {
    try {
      await this.repoLocksRepository.deleteRepoLock(id);

      this.$successDialog.show('Lock dropped successfully');

      await this.search();
    } catch (err) {
      await this.onError(err);
    }
  }

  private async onError(err: unknown): Promise<void> {
    console.log(err);
    const asAxiosError = err as AxiosError;
    if (asAxiosError.isAxiosError) {
      this.$errorDialog.show(asAxiosError.response?.data?.message ?? 'An axios error occurred');
    } else if (err instanceof Error) {
      this.$errorDialog.show(err.message);
    } else {
      this.$errorDialog.show('An unknown error occurred');
    }
  }
}
